export enum InputType {
    text = 'text',
    date = 'date',
    multiSelect = 'multiSelect',
}
